
import { defineComponent, PropType, computed } from 'vue'
import { PPTTextElement } from '@/types/slides'
import useElementShadow from '@/views/components/element/hooks/useElementShadows'
import useElementFlip from '../hooks/useElementFlip'

export default defineComponent({
  name: 'base-element-text',
  components: {},
  props: {
    elementInfo: {
      type: Object as PropType<PPTTextElement>,
      required: true,
    },
  },
  setup(props) {
    const shadow = computed(() => props.elementInfo.shadow)
    const { shadowStyles } = useElementShadow(shadow)
    const flipH = computed(() => props.elementInfo.flipH)
    const flipV = computed(() => props.elementInfo.flipV)
    const { flipStyle } = useElementFlip(flipH, flipV)
    const orderedStops = computed(() => {
      
      return [...props.elementInfo.gradients.g].sort((a, b) => a.p - b.p)
    })
    const getGradientString = (angle:any) => {
      const color = orderedStops.value
        .map((stop) => `${stop.c} ${stop.p}%`)
        .join(",")
      return `linear-gradient(${angle}deg, ${color})`
    }
    return {
      shadowStyles,flipStyle,getGradientString
    }
  },
})
